import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from 'src/app/_services/token.service';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  
  get isSubclient(): boolean {
    return this.tokenService.profileCode === 'SUBCLIENTE';
  };
  get isClient(): boolean {
    return this.tokenService.profileCode === 'CLIENTE';
  };
  
  get isAdmin(): boolean {
    return this.tokenService.profileCode === 'ADMIN';
  };

  get isGestor(): boolean {
    return this.tokenService.profileCode === 'GESTOR';
  };

  constructor(
    private router: Router,
    private tokenService: TokenService
  ) { }

  ngOnInit(): void {  }

  logout(){
    this.router.navigate(['/login']);
  }

  getPortalTitle(): string {
    const profile = this.tokenService.profileCode;
    const base = 'Portal do ';

    switch (profile) {
      case 'ADMIN':
        return base + 'Administrador';

      case 'CLIENTE':
        return base + 'Cliente';
        
      case 'GESTOR':
        return base + 'Gestor';

      default:
        return 'Portal';
    }
  }
}
